export const getRedirectUrl = (language: string) => `${window.location.origin}/auth-callback?lng=${language}`
